<div class="signImageConfig">
  <div #SignImageConfig>
    <ng-container *ngTemplateOutlet="ImageConfigView"></ng-container>
  </div>
</div>

<mat-card *ngIf="isCheckAccessToContract">
  <mat-card-header>
    <mat-card-title><span *ngIf="!isSignDigitalCertificate">{{ "title.signing_document" | translate }}</span>
      <span *ngIf="isSignDigitalCertificate">{{ "title.approving_document" | translate }}</span>
      <span *ngIf="document">{{ document.name }}</span>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content class="mat-card-content-contract-sm">
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" class="mb-0">
        <div class="steps-title" style="height: calc(100vh - 188px)">
          <!--    title của step-->
          <nz-steps [nzCurrent]="current" class="mb-3">
            <nz-step [nzTitle]="titleStep1">
              <ng-template #titleStep1>{{
                "enterprise_contract.image_signing.title_step_1" | translate
                }}</ng-template>
            </nz-step>
            <!-- <ng-container *ngIf="!(isSignDigitalCertificate && !isApproveHaveImageSignature)"> -->
            <nz-step [nzTitle]="titleStep2" *ngIf="isShowImage">
              <ng-template #titleStep2>{{
                "enterprise_contract.image_signing.title_step_2" | translate
                }}</ng-template>
            </nz-step>
            <nz-step [nzTitle]="titleStep3" *ngIf="isShowImage">
              <ng-template #titleStep3>{{
                "enterprise_contract.image_signing.title_step_3" | translate
                }}</ng-template>
            </nz-step>
            <!-- </ng-container> -->
            <nz-step *ngIf="isShowEKYC && isShowImage" [nzTitle]="titleStepEkyc">
              <ng-template #titleStepEkyc>{{'enterprise_contract.image_signing.title_step_ekyc' | translate}}
              </ng-template>
            </nz-step>
            <nz-step [nzTitle]="titleStep4">
              <ng-template #titleStep4>{{
                "enterprise_contract.image_signing.title_step_4" | translate
                }}</ng-template>
            </nz-step>
          </nz-steps>
          <!--end title của step-->

          <!--    nội dung, các phần này thay đổi-->
          <!--    tab chọn phương thức ký-->
          <div [hidden]="current != 0" class="max-width-content-step0">
            <button mat-stroked-button color="primary" type="button" style="margin-left: 24px"
                    *ngIf="isHasPermissionAddCert" (click)="openDialogAddCert()" class="desktop">
              <mat-icon class="mr-0">add_circle</mat-icon>
              {{ "button.add_new_signing_method" | translate }}
            </button>
            <div *ngIf="isPersonalCustomer && !allowOtp" class="pt-3">
              <span style="padding: 0 24px; font-style: italic">{{
                "enterprise_contract.image_signing.not_OTP_for_personal"
                  | translate
                }}
              </span>
            </div>

            <mat-dialog-content class="select-certificate">
              <div class="pb-3 pt-2">
                <ng-container *ngIf="
                    imageCertificates == undefined ||
                      imageCertificates.length == 0;
                    else hasCertificates
                  ">
                  <div style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    ">
                    <span>{{
                      "digital_certificate_management.not_exist_certificate"
                        | translate
                      }}</span>
                    <span *ngIf="!isHasPermissionAddCert">,
                      {{
                      "digital_certificate_management.please_contact_admin"
                        | translate
                      }}</span>
                    <span *ngIf="isHasPermissionAddCert">,
                      {{
                      "digital_certificate_management.please_select_add_cert"
                        | translate
                      }}</span>
                  </div>
                </ng-container>

                <ng-template #hasCertificates>
                  <ng-container *ngFor="let item of imageCertificates">
                    <mat-expansion-panel expanded="true" class="mat-elevation-z0"
                                         *ngIf="(item.type != 0 && item.type != 4) || isHsmPermission">
                      <mat-expansion-panel-header class="example-radio-button" [ngSwitch]="item.type"
                                                  (change)="onSelectImageSignMethod(item.type)" [ngClass]="{
                        'border-none':
                          (!allowOtp && item.type === 3) ||
                          (!allowImage && item.type === 6)
                      }">
                        <mat-panel-title class="mat-panel-title">
                          <ng-container *ngSwitchCase="1">
                            {{
                            "digital_certificate_management.rd_certificate_type.cbx_usb"
                              | translate
                            }}
                          </ng-container>
                          <ng-container *ngSwitchCase="2">
                            {{
                            "digital_certificate_management.rd_certificate_type.cbx_sim_ca"
                              | translate
                            }}
                          </ng-container>
                          <ng-container *ngSwitchCase="4">
                            {{
                            "digital_certificate_management.rd_certificate_type.cbx_hsm"
                              | translate
                            }}
                          </ng-container>
                          <ng-container *ngSwitchCase="0">
                            {{
                            "digital_certificate_management.rd_certificate_type.cbx_server"
                              | translate
                            }}
                          </ng-container>
                          <ng-container *ngIf="allowOtp">
                            <ng-container *ngSwitchCase="3">
                              {{
                              "digital_certificate_management.rd_certificate_type.cbx_otp"
                                | translate
                              }} {{ supportEkyc ? ("digital_certificate_management.rd_certificate_type.ekyc_support"
                              | translate) : '' }}
                            </ng-container>
                          </ng-container>
                          <ng-container *ngIf="allowImage">
                            <ng-container *ngSwitchCase="6">
                              {{
                              "enterprise_contract.image_signing.new_tab.no_select_method"
                                | translate
                              }} {{ supportEkyc ? ("digital_certificate_management.rd_certificate_type.ekyc_support"
                              | translate) : '' }}
                            </ng-container>
                          </ng-container>
                          <ng-container>
                            <ng-container *ngSwitchCase="enumSignMethod.CLOUD_CA">
                              {{
                              "digital_certificate_management.cbx_certificate_type.cbx_cloud_ca"
                                | translate
                              }}
                            </ng-container>
                          </ng-container>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
                                       [(ngModel)]="selectedCert" [ngModelOptions]="{ standalone: true }">
                        <div class="container mat-table-sign-document" *ngIf="item.type != 6 && item.type >= 0">
                          <!-- SIM CA -->
                          <mat-table [dataSource]="item.listCert" *ngIf="item.type == 2">
                            <!-- Chủ thể CTS column -->
                            <ng-container matColumnDef="issuedTo">
                              <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-right-bottom"
                                               style="width: 50%">
                                {{ "digital_certificate_management.issuedTo_name" | translate }}
                              </mat-header-cell>
                              <mat-cell *matCellDef="let cert"
                                        class="mat-cell-non-boder-right-bottom align-middle word-break-line"
                                        style="width: 50%"
                                        matTooltip="{{ cert.issuedTo }}">
                                <div class="pre-wrap">
                                  <mat-radio-button (change)="onChangeSubType(cert)"
                                                    class="ml-2 mt-2 mat-header-cell-center" [value]="cert">
                                    <span class="pre-wrap">{{
                                      cert.issuedTo
                                      }}</span>
                                  </mat-radio-button>
                                </div>
                              </mat-cell>
                            </ng-container>

                            <!-- Serial number column -->
                            <ng-container matColumnDef="serialNumber">
                              <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-right-bottom"
                                               style="max-width: 23%">
                                {{
                                "digital_certificate_management.serial_title"
                                  | translate
                                }}
                              </mat-header-cell>
                              <mat-cell *matCellDef="let cert" class="mat-cell-non-boder-right-bottom word-break-line"
                                        style="max-width: 23%" matTooltip="{{ cert.serialNumber }}">
                                {{ cert.serialNumber }}
                              </mat-cell>
                            </ng-container>

                            <!-- Mã số thuế column -->
                            <ng-container matColumnDef="taxCode">
                              <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-right-bottom"
                                               style="max-width: 15%">
                                {{
                                "digital_certificate_management.mst" | translate
                                }}
                              </mat-header-cell>
                              <mat-cell *matCellDef="let cert"
                                        class="mat-cell-non-boder-right-bottom number-cell-right word-break-line"
                                        style="max-width: 15%" matTooltip="{{ cert.taxCode }}">
                                {{ cert.taxCode }}
                              </mat-cell>
                            </ng-container>

                            <!-- Số điện thoại -->
                            <ng-container matColumnDef="phoneNumber">
                              <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-right-bottom"
                                               style="max-width: 13%">
                                {{
                                "digital_certificate_management.lbl_phone"
                                  | translate
                                }}
                              </mat-header-cell>
                              <mat-cell *matCellDef="let cert"
                                        class="mat-cell-non-boder-right-bottom number-cell-center word-break-line"
                                        style="max-width: 13%" matTooltip="{{ cert.phoneNumber }}">
                                {{ cert.phoneNumber }}
                              </mat-cell>
                            </ng-container>

                            <!-- Ngày hoàn thành column -->
                            <ng-container matColumnDef="expireDate">
                              <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-bottom"
                                               style="max-width: 13%">
                                {{
                                "headertable.end_of_activate_date" | translate
                                }}
                              </mat-header-cell>
                              <mat-cell *matCellDef="let cert"
                                        class="mat-cell-non-boder-bottom number-cell-center word-break-line"
                                        style="max-width: 13%" matTooltip="{{ cert.expireDate | dateformat }}">
                                {{ cert.expireDate | dateformat }}
                              </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="columnsToDisplaySimCA"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: columnsToDisplaySimCA"></mat-row>
                          </mat-table>

                          <!-- Other HSM & Usb Token -->
                          <mat-table [dataSource]="item.listCert"
                                     *ngIf="item.type != 3 && item.type != 2 && item.type != enumSignMethod.CLOUD_CA">
                            <!-- Chủ thể CTS column -->
                            <ng-container matColumnDef="issuedTo">
                              <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-right-bottom"
                                               style="width: 50%">
                                {{ "digital_certificate_management.issuedTo_name" | translate }}
                              </mat-header-cell>
                              <mat-cell *matCellDef="let cert"
                                        class="mat-cell-non-boder-right-bottom align-middle word-break-line"
                                        style="width: 50%"
                                        matTooltip="{{ cert.issuedTo }}">
                                <div class="pre-wrap">
                                  <mat-radio-button (change)="onChangeSubType(cert)"
                                                    class="ml-2 mt-2 mat-header-cell-center" [value]="cert">
                                    <span class="pre-wrap">{{cert.issuedTo}}</span>
                                  </mat-radio-button>
                                </div>
                              </mat-cell>
                            </ng-container>

                            <!-- Serial number column -->
                            <ng-container matColumnDef="serialNumber">
                              <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-right-bottom"
                                               style="max-width: 25%">
                                {{"digital_certificate_management.serial_title"| translate}}
                              </mat-header-cell>
                              <mat-cell *matCellDef="let cert" class="mat-cell-non-boder-right-bottom word-break-line"
                                        style="max-width: 25%" matTooltip="{{ cert.serialNumber }}">
                                {{ cert.serialNumber }}
                              </mat-cell>
                            </ng-container>

                            <!-- Mã số thuế column -->
                            <ng-container matColumnDef="taxCode">
                              <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-right-bottom"
                                               style="max-width: 15%">
                                {{ "digital_certificate_management.mst" | translate }}
                              </mat-header-cell>
                              <mat-cell *matCellDef="let cert"
                                        class="mat-cell-non-boder-right-bottom number-cell-right word-break-line"
                                        style="max-width: 15%" matTooltip="{{ cert.taxCode }}">
                                {{ cert.taxCode }}
                              </mat-cell>
                            </ng-container>
                            <!-- Ngày hết hiệu lực -->
                            <ng-container matColumnDef="expireDate">
                              <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-bottom"
                                               style="max-width: 13%">{{"headertable.end_of_activate_date" | translate}}
                              </mat-header-cell>
                              <mat-cell *matCellDef="let cert"
                                        class="mat-cell-non-boder-bottom number-cell-center word-break-line"
                                        style="max-width: 13%" matTooltip="{{ cert.expireDate | dateformat }}">
                                {{ cert.expireDate | dateformat }}
                              </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="columnsToDisplayOther"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: columnsToDisplayOther"></mat-row>
                          </mat-table>


                          <!--cloud ca-->
                          <mat-table [dataSource]="item.listCert" *ngIf="item.type == enumSignMethod.CLOUD_CA">
                            <!-- Chủ thể CTS column -->
                            <ng-container matColumnDef="issuedTo">
                              <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-right-bottom"
                                               style="width: 50%">
                                {{ "digital_certificate_management.issuedTo_name" | translate }}
                              </mat-header-cell>
                              <mat-cell *matCellDef="let cert"
                                        class="mat-cell-non-boder-right-bottom align-middle word-break-line"
                                        style="width: 50%"
                                        matTooltip="{{ cert.issuedTo }}">
                                <div class="pre-wrap">
                                  <mat-radio-button (change)="onChangeSubType(cert)"
                                                    class="ml-2 mt-2 mat-header-cell-center" [value]="cert">
                                    <span class="pre-wrap">{{cert.issuedTo}}</span>
                                  </mat-radio-button>
                                </div>
                              </mat-cell>
                            </ng-container>

                            <!-- Serial number column -->
                            <ng-container matColumnDef="serialNumber">
                              <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-right-bottom"
                                               style="max-width: 25%">
                                {{"digital_certificate_management.serial_title"| translate}}
                              </mat-header-cell>
                              <mat-cell *matCellDef="let cert" class="mat-cell-non-boder-right-bottom word-break-line"
                                        style="max-width: 25%" matTooltip="{{ cert.serialNumber }}">
                                {{ cert.serialNumber }}
                              </mat-cell>
                            </ng-container>

                            <!-- Mã số thuế column -->
                            <ng-container matColumnDef="taxCode">
                              <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-right-bottom"
                                               style="max-width: 15%">
                                {{ "digital_certificate_management.mst" | translate }}
                              </mat-header-cell>
                              <mat-cell *matCellDef="let cert"
                                        class="mat-cell-non-boder-right-bottom number-cell-right word-break-line"
                                        style="max-width: 15%" matTooltip="{{ cert.taxCode }}">
                                {{ cert.taxCode }}
                              </mat-cell>
                            </ng-container>
                            <!-- Tài khoản cloud ca -->
                            <ng-container matColumnDef="cloudCaUsername">
                              <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-right-bottom"
                                               style="max-width: 15%">
                                {{ "digital_certificate_management.cloud_ca_acc" | translate }}
                              </mat-header-cell>
                              <mat-cell *matCellDef="let cert"
                                        class="mat-cell-non-boder-right-bottom number-cell-right word-break-line"
                                        style="max-width: 15%" matTooltip="{{ cert.cloudCaUserId }}">
                                {{ cert.cloudCaUserId }}
                              </mat-cell>
                            </ng-container>

                            <!-- Ngày hết hiệu lực -->
                            <ng-container matColumnDef="expireDate">
                              <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-bottom"
                                               style="max-width: 13%">{{"headertable.end_of_activate_date" | translate}}
                              </mat-header-cell>
                              <mat-cell *matCellDef="let cert"
                                        class="mat-cell-non-boder-bottom number-cell-center word-break-line"
                                        style="max-width: 13%" matTooltip="{{ cert.expireDate | dateformat }}">
                                {{ cert.expireDate | dateformat }}
                              </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="columnsToDisplayCloudCa"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: columnsToDisplayCloudCa"></mat-row>
                          </mat-table>

                          <!-- OTP -->
                          <div class="container" *ngIf="item.type == 3 && allowOtp">
                            <h6><strong>{{'digital_certificate_management.phone_number' | translate}}</strong></h6>
                            <mat-radio-button (change)="onChangeSubType(cert)" class="example-radio-button w-100"
                                              *ngFor="let cert of item.listCert" [value]="cert" [disabled]="(!isStillQuantityEkyc && supportEkyc)
                              || (isStillQuantityEkyc && supportEkyc && !isCertificateSupport)">
                              <span style="font-size: 16px;">{{cert.phoneNumber}}</span>
                            </mat-radio-button>
                            <p class="error-quantity-ekyc" *ngIf="!isStillQuantityEkyc && supportEkyc">
                              {{'digital_certificate_management.quantity_ekyc_not_enough' | translate}}</p>
                            <p class="error-quantity-ekyc"
                               *ngIf="isStillQuantityEkyc && supportEkyc && !isCertificateSupport">
                              {{'digital_certificate_management.certificate_not_support' | translate}}</p>
                          </div>
                        </div>

                        <div class="container" *ngIf="item.type === 6 && allowImage">
                          <mat-radio-button class="example-radio-button" [value]="item.listCert[0]"
                                            (change)="onSelectImageSignMethod(item.type)" [disabled]="(!isStillQuantityEkyc && supportEkyc)
                            || (isStillQuantityEkyc && supportEkyc && !isCertificateSupport)">
                          </mat-radio-button>
                          {{'enterprise_contract.image_signing.new_tab.no_select_method_detail' | translate}}<br/>
                          <span
                            class="registered-tab-title-note">{{'enterprise_contract.image_signing.new_tab.step2_note'
                            | translate}}</span>
                          <p class="error-quantity-ekyc" *ngIf="!isStillQuantityEkyc && supportEkyc">
                            {{'digital_certificate_management.quantity_ekyc_not_enough' | translate}}</p>
                          <p class="error-quantity-ekyc"
                             *ngIf="isStillQuantityEkyc && supportEkyc && !isCertificateSupport">
                            {{'digital_certificate_management.certificate_not_support' | translate}}</p>

                        </div>
                      </mat-radio-group>
                    </mat-expansion-panel>
                  </ng-container>
                </ng-template>
              </div>
            </mat-dialog-content>
          </div>
          <!--    end tab chọn phương thức ký-->


          <!-- <ng-container *ngIf="!(isSignDigitalCertificate && !isApproveHaveImageSignature)"> -->
          <!-- tab chọn ảnh chữ ký -->
          <div class="steps-content max-width-content-step1" *ngIf="current == 1 && isShowImage">
            <nz-tabset [nzTabPosition]="'top'" [nzType]="'card'" [(nzSelectedIndex)]="indexSelect"
                       (nzSelectChange)="nzSelectChange($event.index)">
              <!-- tab ảnh đã đăng ký -->
              <nz-tab [nzTitle]="registeredImage"
                      *ngIf="selectedCert.typeCertificate !== signMethod.SIGN_NO_CERT && selectedCert.imageUrl">
                <ng-template #registeredImage>
                  {{
                  "enterprise_contract.image_signing.registered_tab.tab_name"
                    | translate
                  }}</ng-template>
                <div class="tab-content">
                  <div *ngIf="onlyDigital">
                    <div class="default-system-signature"></div>
                    <span class="guiding-info">
                      ({{
                      "enterprise_contract.image_signing.registered_tab.no_image.only_digital"
                        | translate
                      }}) <br/>
                    </span>
                  </div>
                  <div *ngIf="selectedCert.imageUrl && !onlyDigital">
                    <img [src]="sanitize(selectedCert.imageUrl)" style="max-width: 600px; max-height: 300px"/>
                  </div>
                  <div *ngIf="!selectedCert.imageUrl && !onlyDigital">
                    <div *ngIf="
                        selectedCert.typeCertificate === signMethod.SIGN_OTP
                      " class="default-system-signature">
                      <span *ngIf="!isSignDigitalCertificate">{{
                        "enterprise_contract.image_signing.registered_tab.no_image.signed_by"
                          | translate
                        }}:</span>
                      <span *ngIf="isSignDigitalCertificate">{{
                        "enterprise_contract.image_signing.registered_tab.no_image.approver_by"
                          | translate
                        }}:</span>
                      {{ enterpriseName }}
                      <br/>
                      {{
                      "enterprise_contract.image_signing.registered_tab.no_image.signed_phone"
                        | translate
                      }}:
                      {{ selectedCert.phoneNumber }}
                      <br/>
                      <span *ngIf="!isSignDigitalCertificate">{{
                        "enterprise_contract.image_signing.registered_tab.no_image.signed_date"
                          | translate
                        }}:</span>
                      <span *ngIf="isSignDigitalCertificate">{{
                        "enterprise_contract.image_signing.registered_tab.no_image.approver_date"
                          | translate
                        }}:</span>
                      {{ currentDate | dateformat }}
                      <br/>
                      <ng-container *ngIf="!isNotAttestedUser">
                        {{
                        "enterprise_contract.image_signing.registered_tab.no_image.verified_info"
                          | translate
                        }}
                      </ng-container>
                    </div>

                    <div
                      *ngIf="selectedCert.typeCertificate === signMethod.SIGN_NO_CERT
                      || selectedCert.typeCertificate === signMethod.SIGN_EKYC || selectedCert.typeCertificate === signMethod.SIGN_EKYC_ADVANCED"
                      class="default-system-signature">
                      <ng-container *ngIf="!onlyDigital">
                        <span *ngIf="!isSignDigitalCertificate">{{
                          "enterprise_contract.image_signing.registered_tab.no_image.signed_by"
                            | translate
                          }}:</span>
                        <span *ngIf="isSignDigitalCertificate">{{
                          "enterprise_contract.image_signing.registered_tab.no_image.approver_by"
                            | translate
                          }}:</span>
                        {{enterpriseName}}
                        <br/>
                        <span *ngIf="!isSignDigitalCertificate">{{
                          "enterprise_contract.image_signing.registered_tab.no_image.signed_date"
                            | translate
                          }}:</span>
                        <span *ngIf="isSignDigitalCertificate">{{
                          "enterprise_contract.image_signing.registered_tab.no_image.approver_date"
                            | translate
                          }}:</span>
                        {{currentDate | dateformat}}
                        <br/>
                        <ng-container *ngIf="!isNotAttestedUser">
                          {{'enterprise_contract.image_signing.registered_tab.no_image.verified_info' | translate}}
                        </ng-container>
                      </ng-container>

                    </div>

                    <div
                      *ngIf="selectedCert.typeCertificate !== signMethod.SIGN_OTP && selectedCert.typeCertificate !== signMethod.SIGN_NO_CERT
                        && selectedCert.typeCertificate !== signMethod.SIGN_EKYC && selectedCert.typeCertificate !== signMethod.SIGN_EKYC_ADVANCED"
                      class="default-system-signature">
                      <ng-container *ngIf="!onlyDigital">
                        <span *ngIf="!isSignDigitalCertificate">{{
                          "enterprise_contract.image_signing.registered_tab.no_image.signed_by"
                            | translate
                          }}:</span>
                        <span *ngIf="isSignDigitalCertificate">{{
                          "enterprise_contract.image_signing.registered_tab.no_image.approver_by"
                            | translate
                          }}:</span>
                        {{selectedCert.issuedTo}}
                        <br/>
                        <span *ngIf="!isSignDigitalCertificate">{{
                          "enterprise_contract.image_signing.registered_tab.no_image.signed_date"
                            | translate
                          }}:</span>
                        <span *ngIf="isSignDigitalCertificate">{{
                          "enterprise_contract.image_signing.registered_tab.no_image.approver_date"
                            | translate
                          }}:</span>
                        {{currentDate | dateformat}}
                      </ng-container>
                    </div>
                    <span class="guiding-info">
                      <ng-container *ngIf="onlyDigital">
                        ({{'enterprise_contract.image_signing.registered_tab.no_image.only_digital' | translate}}) <br>
                      </ng-container>
                      {{'enterprise_contract.image_signing.registered_tab.no_image.guiding' | translate}} <br>
                    </span>
                  </div>
                </div>
              </nz-tab>

              <!-- Tab ảnh mặc định hệ thống -->
              <nz-tab [nzTitle]="'enterprise_contract.image_signing.new_tab.system_image' | translate">
                <div class="tab-content">
                  <app-image-sign-config [selectedCert]="selectedCert"
                                         [enterpriseName]="enterpriseName"
                                         [signConfig]="signConfig"
                                         [domRenderImage]="SignImageConfig"
                                         [signMethod]="signMethod"
                                         [scopeType]="scopeType"
                                         [generationId]="activeTabGenerationId">
                    <ng-container *ngTemplateOutlet="ImageConfigView"></ng-container>
                  </app-image-sign-config>
                </div>
              </nz-tab>

              <!-- tab tải ảnh mới lên -->
              <nz-tab [nzTitle]="uploadImage" *ngIf="
                  !onlyDigital ||
                  selectedCert.typeCertificate === signMethod.SIGN_NO_CERT
                ">
                <ng-template #uploadImage>{{
                  "enterprise_contract.image_signing.new_tab.upload_image"
                    | translate
                  }}
                </ng-template>
                <div class="tab-content">
                  <div class="row">
                    <div class="clearfix nz-upload-clearfix">
                      <nz-upload [nzAccept]="'image/jpeg,image/jpg,image/png'" [nzPreview]="handlePreview"
                                 class="avatar-uploader px-3 pt-3" [nzCustomRequest]="dummyRequest" nzName="avatar"
                                 nzListType="picture-card" [nzShowUploadList]="false" [nzBeforeUpload]="beforeUpload"
                                 (nzChange)="handleChange($event)">
                        <ng-container *ngIf="!avatarUrl">
                          <i class="upload-icon" nz-icon [nzType]="loading ? 'loading' : 'plus'"></i>
                          <div class="ant-upload-text">
                            {{ "form.select_upload" | translate }}
                          </div>
                        </ng-container>
                        <img *ngIf="avatarUrl" [src]="sanitize(avatarUrl)"
                             style="max-height: 300px; max-width: 600px"/>
                      </nz-upload>
                    </div>
                  </div>

                  <span class="guiding-info pt-4 pb-4">{{ "title.upload_image_sign_guiding1" | translate }}
                    <br/>{{
                    "title.upload_image_sign_guiding2" | translate
                    }}</span>
                </div>
              </nz-tab>

              <!-- tab vẽ chữ ký desktop -->
              <nz-tab [nzTitle]="drawSignature" (nzSelect)="onSelectDrawSign()"
                      *ngIf="!onlyDigital || selectedCert.typeCertificate === signMethod.SIGN_NO_CERT">
                <ng-template #drawSignature>{{
                  "enterprise_contract.image_signing.new_tab.draw_signature"
                    | translate
                  }}
                </ng-template>

                <div class="steps-content">
                  <div class="tab-content">
                    <app-canvas [canvasWidth]="canvasWidth" [canvasHeight]="canvasHeight"></app-canvas>
                  </div>
                </div>
              </nz-tab>
            </nz-tabset>
          </div>

          <!-- tab chọn vị trí hiển thị chữ ký -->
          <div class="parent-document steps-content"
               *ngIf="(current==2 || (current == 3 && !isShowEKYC)) && isShowImage"
               class="max-width-content-step23" [class.landscape]="isViewLandscape">
            <div class="document scrollbar_scontract_xs">
              <p class="note mobile" *ngIf="isAllowSelectSignPosition"><i><span
                class="material-icons mr-1">warning</span>{{ "messages.click_to_select_sign_position" | translate
                }}</i></p>
              <div class="d-flex box-tab" id="box-center" style="width: 100%">
                <div class="px-2 py-2 tab" *ngFor="let file of document.mainContractAttachments; let i = index"
                     [class.active]="i === activeFile" (click)="changeFile(file.path, i)" [matTooltip]="file.fileName"
                     [class.error-tab]="checkFileNotHaveSign(file.id) && i !== activeFile"
                     [class.border-right]="i !== document.mainContractAttachments.length - 1 && i !== activeFile && i !== activeFile - 1">
                  <div class="name">
                    {{ file.fileName }}
                  </div>
                </div>
              </div>
              <div>
                <ng-container>
                  <!--                                    <pdf-viewer class="pdf-viewer" [src]="pdfSrc" (page-rendered)="pageRendered($event)"-->
                  <!--                                                [render-text]="true" [zoom]="zoomLevel" (text-layer-rendered)="textLayerRendered($event)"-->
                  <!--                                                (mousedown)="onMouseClickPdfViewer()">-->
                  <!--                                    </pdf-viewer>-->
                  <ngx-extended-pdf-viewer [textLayer]="true" [src]="pdfSrc" (pageRendered)="pageRendered($event)"
                                           (textLayerRendered)="textLayerRendered($event)" [(zoom)]="zoomLevel"
                                           [(page)]="pageCurrent"
                                           [showToolbar]="true" useBrowserLocale="true"
                                           height="calc(100vh - 273px - 4rem)" [handTool]="false"
                                           [enablePrint]="false" [showDownloadButton]="false" [sidebarVisible]="true"
                                           [showRotateButton]="false" [showOpenFileButton]="false"
                                           [showBookmarkButton]="false"
                                           [showPropertiesButton]="true" [showUnverifiedSignatures]="true"
                                           [theme]="'dark'"
                                           [language]="language" [zoomLevels]="[0.5, 1, 1.25, 1.5, 2, 3, 4]"
                                           [showSidebarButton]="isShowSidebarButton" [httpHeaders]="authorization">
                  </ngx-extended-pdf-viewer>
                </ng-container>
                <ng-template #notUpload>
                  <div *ngIf="pdfSrc" class="doc-wrapper view-document" [innerHTML]="pdfSrc | noSanitize"></div>
                </ng-template>
              </div>
            </div>
          </div>
          <!-- </ng-container> -->

          <!-- tab ký (hiển thị xác thực EKYC và EKYC nâng cao) -->
          <!-- <div class="parent-document steps-content" *ngIf="isShowEKYC && (current == 3)"> -->
          <!-- <ng-container *ngIf="!isReloadCamera"> -->
          <!-- <div class="parent-document steps-content" [style.display]="isShowEKYC && (current == 3) ? 'block' : 'none'">
            <div style="margin-top: 32px;" class="document scrollbar_scontract_xs">
              <app-ekyc-camera
                [isPassport]="isPassport">
              </app-ekyc-camera>
            </div>
          </div> -->
          <ng-container *ngIf="!isReloadCamera">
            <div class="parent-document steps-content" [style.display]="isShowEKYC && (current == 3) ? 'block' : 'none'"
                 class="max-width-content-step23">
              <div class="document scrollbar_scontract_xs">
                <div>
                  <app-ekyc-camera [isPassport]="isPassport">
                  </app-ekyc-camera>
                </div>
              </div>
            </div>
          </ng-container>
          <!-- </ng-container> -->
          <!--    end nội dung, các phần này thay đổi-->
        </div>
      </mat-expansion-panel>

      <!-- Button show desktop, tablet -->
      <div
        class="scontract-btn-dsk scontract-btn-deskbg-white boder-create-contract text-center mat-elevation-z0 py-2 w-100"
        id="navigation" #navigation style="border-top: 1px solid #0000001f; background: white;">
        <button id="btn-cancel" mat-stroked-button color="primary" class="mr-3" type="button"
                (click)="onClickBtnCancel()">
          <mat-icon class="mr-0">cancel</mat-icon>
          {{ "button.cancel" | translate }}
        </button>
        <!--      nút quay lại voi phuong thuc ky mac dinh-->
        <button (click)="preCurentOne()" *ngIf="isCertificateDefault" mat-stroked-button class="mr-3" color="primary">
          <mat-icon class="mr-0">arrow_back</mat-icon>
          {{'button.back_default' | translate}}
        </button>
        <!--      nút quay lại-->
        <button (click)="pre()" *ngIf="current > 0 && !isCertificateDefault" mat-stroked-button class="mr-3"
                color="primary">
          <mat-icon class="mr-0">arrow_back</mat-icon>
          {{ "button.back" | translate }}
        </button>
        <!--      nút tiếp tục -->
        <button (click)="next()" *ngIf="current < 2" mat-raised-button class="mr-3" color="primary"
                [disabled]="disableNextButton()">
          {{'button.next' | translate}}
          <mat-icon class="mr-0">arrow_forward</mat-icon>
        </button>
        <!--      đến trang ký -->
        <!-- <button
          (click)="gotoSignPage()"
          *ngIf="current === 2"
          mat-stroked-button
          class="mr-3"
          color="primary"
        >
          <mat-icon class="mr-0">pin_drop</mat-icon>
          {{ "enterprise_contract.buttons.goto_signing_page" | translate }}
        </button> -->
        <button mat-stroked-button color="primary" class="mr-3" (click)="onStamped()"
                *ngIf="current === 2 && isAllowSelectSignPosition">
          <mat-icon class="mr-0">replay</mat-icon>
          {{ "enterprise_contract.buttons.re_select_position" | translate }}
        </button>
        <button mat-raised-button color="primary" class="mr-3" (click)="checkTimestampMoney()"
                *ngIf="current === 2 || current === 3" [disabled]="!disableSignBtn">
          <mat-icon class="mr-0">gesture</mat-icon>
          <span *ngIf="!isSignDigitalCertificate">{{ "enterprise_contract.buttons.sign" | translate }}</span>
          <span *ngIf="isSignDigitalCertificate">{{ "enterprise_contract.buttons.approve" | translate }}</span>
        </button>
      </div>
    </mat-accordion>
  </mat-card-content>
</mat-card>

<div class="row">
  <!-- Button show mobile -->
  <div class="scontract-btn-mobile bg-white text-center shadow-lg rounded">
    <ngx-slick-carousel #btnView class="carousel" #slickModal="slick-carousel" [config]="slideButtonConfig">
      <div ngxSlickItem class="flex-fill slide" (click)="onClickBtnCancel()">
        <mat-icon>cancel</mat-icon>
        <h6 class="mb-0">{{ "button.cancel" | translate }}</h6>
      </div>
      <div ngxSlickItem class="flex-fill slide" (click)="pre()" *ngIf="current > 0">
        <mat-icon>arrow_back</mat-icon>
        <h6 class="mb-0">{{ "form.back" | translate }}</h6>
      </div>
      <div ngxSlickItem class="flex-fill slide" (click)="next()" *ngIf="current == 0">
        <mat-icon>arrow_forward</mat-icon>
        <h6 class="mb-0">{{ "button.next" | translate }}</h6>
      </div>
      <div ngxSlickItem class="flex-fill slide" (click)="next()"
           *ngIf="current > 0 && current < 2 && !isDisableNextButton && selectedCert.typeCertificate !== undefined">
        <mat-icon>arrow_forward</mat-icon>
        <h6 class="mb-0">{{ "button.next" | translate }}</h6>
      </div>
      <!-- <div
        ngxSlickItem
        class="flex-fill slide"
        (click)="gotoSignPage()"
        *ngIf="current === 2"
      >
        <mat-icon>pin_drop</mat-icon>
        <h6 class="mb-0">
          {{ "enterprise_contract.buttons.goto_signing_page" | translate }}
        </h6>
      </div> -->

      <div ngxSlickItem class="flex-fill slide" (click)="onStamped()"
           *ngIf="current === 2 && isAllowSelectSignPosition">
        <mat-icon>replay</mat-icon>
        <h6 class="mb-0">{{'enterprise_contract.buttons.re_select_position' | translate}}</h6>
      </div>

      <div ngxSlickItem class="flex-fill slide" (click)="checkTimestampMoney()"
           *ngIf="(current === 2 || current === 3) && disableSignBtn">
        <mat-icon>gesture</mat-icon>
        <h6 class="mb-0" *ngIf="!isSignDigitalCertificate">
          {{ "enterprise_contract.buttons.sign" | translate }}
        </h6>
        <h6 class="mb-0" *ngIf="isSignDigitalCertificate">
          {{ "enterprise_contract.buttons.approve" | translate }}
        </h6>
      </div>
    </ngx-slick-carousel>

    <!-- <ngx-slick-carousel #btnView class="carousel" #slickModal="slick-carousel" [config]="slideButtonConfig">
      <div ngxSlickItem class="flex-fill slide" *ngFor="let slide of slidesButtons; let i = index;" (click)="onClickCallFunction(slide.id)">
        <mat-icon>{{slide.icon}}</mat-icon>
        <h6 class="mb-0">{{slide.text}}</h6>
      </div>
    </ngx-slick-carousel> -->
  </div>
</div>

<app-page-not-found-no-access *ngIf="!isCheckAccessToContract" (backToPrevPage)="backToPrePage()">
</app-page-not-found-no-access>

<ng-template #ImageConfigView>
  <ng-container *ngIf="!signConfig?.signatureImage.enabled;else noSignatureImage">
    <div style="padding: 20px;" [style.width]="'1184px'" [style.height]="'528px'"
         class="image-config_view__content align-items-center d-flex flex-row">
      <ng-container *ngTemplateOutlet="ImageViewContent"></ng-container>
    </div>
  </ng-container>
  <ng-template #noSignatureImage>
    <ng-container [ngSwitch]="signConfig?.signaturePosition?.value">
      <div style="padding: 20px;" *ngSwitchCase="'left'" [style.width]="'1464px'" [style.height]="'528px'"
           class="image-config_view__content d-flex align-items-center justify-content-center flex-row">
        <div class="d-flex justify-content-center align-items-center"
             [style.flex]="getNumber(signConfig.signatureRatio.value)[0]">
          <ng-container *ngTemplateOutlet="SignatureViewContent"></ng-container>
        </div>
        <div style="padding-left: 24px;" class="d-flex justify-content-start align-items-center"
             [style.flex]="getNumber(signConfig.signatureRatio.value)[1]">
          <ng-container *ngTemplateOutlet="ImageViewContent"></ng-container>
        </div>
      </div>
      <div style="padding: 20px;" *ngSwitchCase="'right'" [style.width]="'1464px'" [style.height]="'528px'"
           class="image-config_view__content d-flex align-items-center justify-content-center flex-row-reverse">
        <div class="d-flex justify-content-center align-items-center"
             [style.flex]="getNumber(signConfig.signatureRatio.value)[0]">
          <ng-container *ngTemplateOutlet="SignatureViewContent"></ng-container>
        </div>
        <div style="padding-left: 24px;" class="d-flex justify-content-start align-items-center"
             [style.flex]="getNumber(signConfig.signatureRatio.value)[1]">
          <ng-container *ngTemplateOutlet="ImageViewContent"></ng-container>
        </div>
      </div>
      <div style="padding: 20px;" *ngSwitchCase="'top'" [style.width]="'1184px'" [style.height]="'932px'"
           class="image-config_view__content d-flex align-items-center justify-content-center flex-column">
        <div class="d-flex justify-content-center align-items-center"
             [style.height]="signConfig.signatureImage.enabled ? (+getNumber(signConfig.signatureRatio.value)[0] / 100) * 233 * 4 + 'px' : (+getNumber(signConfig.signatureRatio.value)[0] / 100) * 132 * 4 + 'px'">
          <ng-container *ngTemplateOutlet="SignatureViewContent"></ng-container>
        </div>
        <div class="d-flex justify-content-start align-items-center"
             [style.height]="signConfig.signatureImage.enabled ? (+getNumber(signConfig.signatureRatio.value)[1] / 100) * 233 * 4 + 'px' : (+getNumber(signConfig.signatureRatio.value)[1] / 100) * 132 * 4 + 'px'">
          <ng-container *ngTemplateOutlet="ImageViewContent"></ng-container>
        </div>
      </div>
      <div style="padding: 20px;" *ngSwitchCase="'bottom'" [style.width]="'1184px'" [style.height]="'932px'"
           class="image-config_view__content d-flex align-items-center justify-content-center flex-column-reverse">
        <div class="d-flex justify-content-center align-items-center"
             [style.height]="signConfig.signatureImage.enabled ? (+getNumber(signConfig.signatureRatio.value)[0] / 100) * 233 * 4 + 'px' : (+getNumber(signConfig.signatureRatio.value)[0] / 100) * 132 * 4 + 'px'">
          <ng-container *ngTemplateOutlet="SignatureViewContent"></ng-container>
        </div>
        <div class="d-flex justify-content-start align-items-center"
             [style.height]="signConfig.signatureImage.enabled ? (+getNumber(signConfig.signatureRatio.value)[1] / 100) * 233 * 4 + 'px' : (+getNumber(signConfig.signatureRatio.value)[1] / 100) * 132 * 4 + 'px'">
          <ng-container *ngTemplateOutlet="ImageViewContent"></ng-container>
        </div>
      </div>
    </ng-container>
  </ng-template>
</ng-template>

<ng-template #SignatureViewContent>
  <ng-container *ngIf="signConfig.signatureImageBase64.value.split(',')[1]">
    <ng-container
      *ngIf="signConfig?.signaturePosition?.value === 'left' || signConfig?.signaturePosition?.value === 'right'">
      <img
        [style.max-height]="'508px'"
        [style.max-width]="346 * 4 * (+getNumber(signConfig.signatureRatio.value)[0] / 100) + 'px'"
        [src]="signConfig.signatureImageBase64.value">
    </ng-container>
    <ng-container
      *ngIf="signConfig?.signaturePosition?.value === 'top' || signConfig?.signaturePosition?.value === 'bottom'">
      <img
        [style.max-width]="'1164px'"
        [style.height]="imageSignConfig?.widthImageSignature < 346 * 4 * (+getNumber(signConfig.signatureRatio.value)[0] / 100) ? (217 * 4 * (+getNumber(signConfig.signatureRatio.value)[0] / 100) + 28) + 'px' : 'auto'"
        [style.max-height]="(217 * 4 * (+getNumber(signConfig.signatureRatio.value)[0] / 100) + 28) + 'px'"
        [src]="signConfig.signatureImageBase64.value">
    </ng-container>
  </ng-container>
</ng-template>
<ng-template #ImageViewContent>
  <div id="imageConfigContainer" class="imageConfigContainer">
    <ng-container *ngFor="let key of getConfigKeyList()">
      <ng-container *ngTemplateOutlet="ConfigViewItem; context: {$implicit: key}"></ng-container>
    </ng-container>

    <ng-container *ngIf="signConfig.greenTick.enabled">
      <div class="green-tick"
           [style.top]="signConfig.signaturePosition.value ? 18 * 4 * (+getNumber(signConfig.signatureRatio.value)[1] / 100) + 'px' : '72px'"
           [style.left]="signConfig.signaturePosition.value ? 46 * 4 * (+getNumber(signConfig.signatureRatio.value)[1] / 100) + 'px' : '184px'"
      >
        <svg width="316" height="232" viewBox="0 0 79 58" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
                d="M77.2308 2.10253C78.9231 3.7948 78.9231 6.53852 77.2308 8.23079L29.5641 55.8975C27.8719 57.5897 25.1281 57.5897 23.4359 55.8975L1.7692 34.2308C0.0769319 32.5385 0.0769319 29.7948 1.7692 28.1025C3.46148 26.4103 6.20519 26.4103 7.89746 28.1025L26.5 46.7051L71.1025 2.10253C72.7948 0.41026 75.5385 0.41026 77.2308 2.10253Z"
                fill="#52C41A"/>
        </svg>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #ConfigViewItem let-data>
  <div [style.font-style]="signConfig.fontStyle.value || ''" [style.font-weight]="signConfig.fontWeight.value || ''"
       [style.fontFamily]="signConfig.fontFamily.value || 'Times-Roman'" *ngIf="showConfig(data)"
       class="view-content-item">
    <ng-container *ngIf="data == 'signatureImage' || data == 'isDraw'; else displayColon"></ng-container>
    <ng-template #displayColon>
      <div style="word-break: break-word;" [style.textAlign]="signConfig.contentPosition.value">
        {{signConfig[data].label | translate}}: {{signConfig[data].value}}
      </div>
    </ng-template>

    <!--        <div [style.font-style]="signConfigClone.fontStyle.value || ''" [style.font-weight]="signConfigClone.fontWeight.value || ''" [style.fontFamily]="signConfigClone.fontFamily.value || 'Times-Roman'" class="label"></div>&nbsp;-->

    <!--      <div [style.font-style]="signConfigClone.fontStyle.value || ''" [style.font-weight]="signConfigClone.fontWeight.value || ''" [style.fontFamily]="signConfigClone.fontFamily.value || 'Times-Roman'" align="start" style="word-break: break-word; white-space: pre-wrap;">-->
    <!--        <ng-container>-->
    <!--          {{signConfigClone[data].value}}-->
    <!--        </ng-container>-->
    <!--      </div>-->
  </div>
</ng-template>

<!--<ng-template #ImageConfig>-->
<!--  <div class="image-config_view__content">-->
<!--    <div id="imageConfigContainer">-->
<!--      <ng-container *ngFor="let key of getConfigKeyList()">-->
<!--        <ng-container *ngTemplateOutlet="ConfigViewItem; context: {$implicit: key}"></ng-container>-->
<!--      </ng-container>-->

<!--      <div *ngIf="signConfig.greenTick.enabled" class="green-tick">-->
<!--        <svg width="158" height="116" viewBox="0 0 79 58" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--          <path fill-rule="evenodd" clip-rule="evenodd" d="M77.2308 2.10253C78.9231 3.7948 78.9231 6.53852 77.2308 8.23079L29.5641 55.8975C27.8719 57.5897 25.1281 57.5897 23.4359 55.8975L1.7692 34.2308C0.0769319 32.5385 0.0769319 29.7948 1.7692 28.1025C3.46148 26.4103 6.20519 26.4103 7.89746 28.1025L26.5 46.7051L71.1025 2.10253C72.7948 0.41026 75.5385 0.41026 77.2308 2.10253Z" fill="#52C41A"/>-->
<!--        </svg>  -->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</ng-template>-->

<!--<ng-template #ConfigViewItem let-data>-->
<!--  <div *ngIf="showConfig(data)" class="view-content-item" style="font-family: Roboto>-->
<!--    <div class="label" >{{signConfig[data].label | translate}}:</div>&nbsp;-->
<!--    <div align="start" style="word-break: break-word">-->
<!--      <ng-container>-->
<!--        {{signConfig[data].value}}-->
<!--      </ng-container>-->
<!--    </div>-->
<!--  </div>-->
<!--</ng-template>-->
